<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fas fa-users"></i> Felhasználók
        </h1>
      </div>
      <div class="ms-auto" v-if="user.role_id == 1">
        <router-link
          to="/base-data/users/permits"
          class="btn btn-blue btn-rounded px-4 rounded-pill me-2"
          ><i
            class="fa fa-file-signature fa-lg me-2 ms-n2 text-success-900"
          ></i>
          Szakvizsgák</router-link
        >
        <button
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addUserModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
          felhasználó
        </button>
      </div>
    </div>
    <AddUserModal
      v-on:user-added="addUserToTable"
      title="Felhasználó létrehozása"
    ></AddUserModal>
    <div class="row">
      <div class="col-12">
        <panel title="Felhasználók">
          <Loading
            v-if="users === false || roles === false"
            title="Felhasználók betöltése"
          ></Loading>
          <NoRecords
            v-if="users.length == 0"
            main_icon="fas fa-users"
            value="false"
            title="Nincsenek felhasználók"
            subtitle="hozzon létre újat"
          ></NoRecords>
          <vue-good-table
            v-if="users.length != 0 && users !== false && roles != false"
            :columns="columns"
            :rows="users_with_name_extension"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'actions' && user.role_id == 1">
                <setPinButton
                  :user="props.row"
                  @pinset="setPinSet(props.row.id, $event)"
                ></setPinButton>
                <router-link
                  :to="'/base-data/users/' + props.row.id + '/edit'"
                  class="btn btn-primary btn-xs mx-1"
                  title="szerkesztés"
                  ><i class="fa fa-edit"></i
                ></router-link>
                <button
                  @click="confirmDelete(props.row.id)"
                  class="btn btn-danger btn-xs mx-1"
                  title="törlés"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </span>
              <span v-else-if="props.column.field == 'green_lock_number'">
                <span class="fa-stack" v-if="props.row.green_lock_number">
                  <i class="fa-solid fa-lock fa-stack-2x text-green"></i>
                  <i class="fa-solid fa-stack-1x text-white fs-9px mt-5px">{{
                    props.row.green_lock_number
                  }}</i>
                </span>
                <span v-else class="badge bg-light text-black"
                  >nincs kiadva</span
                >
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import User from "../../apis/User";
/*import Config from "../../apis/Config"; */
import Confirmation from "../../apis/Confirmation";
import AddUserModal from "../../components/AddUserModal";
import SetPinButton from "../../components/SetPinButton";

export default {
  components: {
    Loading,
    NoRecords,
    AddUserModal,
    SetPinButton,
  },
  data() {
    return {
      columns: [
        {
          label: "Név",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Email",
          field: "email",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az email címek között",
          },
        },
        {
          label: "Értesítési email",
          field: "notification_email",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az email címek között",
          },
          hidden: true,
        },
        {
          label: "Telefonszám",
          field: "phone",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az telefonszámok között",
          },
        },
        {
          label: "Munkakör",
          field: "workjob",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a munkakörök között",
          },
          sortFn: this.greenLockSort,
        },
        {
          label: "Zöld lakat",
          field: "green_lock_number",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a zöld lakatok között",
          },
          sortFn: this.greenLockSort,
        },
        {
          label: "Jogosultság",
          field: this.roleField,
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a jogosultságok között",
          },
        },
        /*{
						label: 'Létrehozás dátuma',
						field: 'created_at',
						type: 'date',
						dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX',
						dateOutputFormat: 'yyyy-MM-dd',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés a létrehozási dátumok között',
						}
					},*/
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      users: false,
      roles: false,
    };
  },
  computed: {
    users_with_name_extension() {
      if (this.users) {
        return this.users.map((u) => ({
          id: u.id,
          first_name: u.first_name,
          last_name: u.last_name,
          name_extension: u.name_extension,
          original_role_id: u.original_role_id,
          role_id: u.role_id,
          roles: u.roles,
          partner_id: u.partner_id,
          email: u.email,
          phone: u.phone,
          name:
            u.last_name +
            " " +
            u.first_name +
            (u.name_extension != null ? " " + u.name_extension : "") +
            (u.partner_id != null ? " (" + u.partner_name + ")" : ""),
          partner_name: u.partner_name,
          has_valid_fire_certificate: u.has_valid_fire_certificate,
          pin_set: u.pin_set,
          partner: u.partner,
          green_lock_number: u.green_lock_number,
          workjob: u.workjob,
        }));
      } else {
        return [];
      }
    },
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    /*Config.getConstant('roles')
			.then(response => {
				this.roles = JSON.parse(JSON.stringify(response.data));
			});*/
    this.roles = JSON.parse(localStorage.getItem("constants")).roles;
    User.index().then((response) => {
      this.users = response.data;
    });
  },
  methods: {
    greenLockSort(x, y) {
      return String(x).padStart(6, "0") < String(y).padStart(6, "0")
        ? -1
        : String(x).padStart(6, "0") > String(y).padStart(6, "0")
        ? 1
        : 0;
    },
    setPinSet(id, event) {
      this.users.find((u) => u.id == id).pin_set = event;
    },
    addUserToTable(user) {
      this.users.unshift(user);
    },
    confirmDelete(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          this.deleteUser(id);
        }
      });
    },
    roleField(rowObj) {
      return this.roles[this.roles.map((r) => r.id).indexOf(rowObj.role_id)]
        .name;
    },
    deleteUser(id) {
      User.delete(id).then(() => {
        this.users.splice(this.users.map((user) => user.id).indexOf(id), 1);
      });
    },
  },
};
</script>

<style></style>
